import React from 'react';
import styled from 'styled-components';

import { Text } from 'components/Text';

export const InfoItems = styled.div`
  display: flex;
  flex-direction: column;

  & > *:not(:last-child) {
    margin-bottom: 24px;
  }
`;

const StyledInfoItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  & .name {
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    color: #A4B0BA;
  }
`;

const InfoItem = ({ name, value, children, ...rest }) => (
  <StyledInfoItem {...rest}>
    <Text className="name">{name}:</Text>
    {value || children || '-'}
  </StyledInfoItem>
);

export default InfoItem;
